<template>
  <div class="hide-overflow">
    <div class="orange">
      <div class="width-100">
        <img class="maxsize" src="https://storage.googleapis.com/storage-public-images/logos/movida-white.png" />
      </div>
    </div>
    <div class="content-padding">
      <v-row>
        <v-col cols="12">
          <h1 class="text-center titles-1" v-if="title_size">{{ process_name }}</h1>
          <h2 class="text-center titles-2" v-else>{{ process_name }}</h2>
        </v-col>
      </v-row>
      <v-row v-if="this.are_there_docs">
        <v-col cols="12">
          <h2 class="text-center titles-2">Documentos a assinar</h2>
        </v-col>
      </v-row>
      <div v-if="are_there_docs">
        <div v-for="(document, document_index) in signature_process?.signature_documents" :key="document_index">
          <v-row id="members-list" v-for="(member, member_index) in document.members" :key="member_index">
            <v-col cols="6">
              <p class="text-center text-font clickable" :id="'docp-' + document_index + '-' + member_index" @click="getPdf(document.id, 'docp-' + document_index + '-' + member_index)">{{ document.name }}</p>
            </v-col>
            <v-col cols="6">
              <!-- verifica se está assinado -->
              <div v-if="member.signature_file">
                <p class="text-center signed-background-color text-font"> Assinante: {{ member.name }} {{ member.document.length > 1 ? "- " + member.document : "" }} - Assinado em {{ member.updated_at }} </p>
              </div>
              <div v-else>
                <p class="text-center unsigned-background-color text-font"> Assinante: {{ member.name }} {{ member.document.length > 1 ? "- " + member.document : "" }} </p>
              </div>
            </v-col>
          </v-row>
        </div>
        <hr />
      </div>
    </div>
    <div v-if="show_signe_finish_buttons">
      <a v-if="unsigned_docs" class="actionBtn" id="btn-assinar" @click="signeIt">
        <b>Assinar</b>
      </a>
      <a v-else class="actionBtn" :class="{ 'disabled-btn': disable_finish_button }" id="btn-finalizar" @click="finishSignatureProcess">
        <b>Finalizar</b>
      </a>
    </div>
    <v-container>
      <v-dialog v-model="modal_open" @click:outside="modal_open = false" width="auto" content-class="dialog-model-content" scrollable transition="dialog-bottom-transition">
        <v-container class="modal-background-color">
          <h2 class="text-center h2-doc-name"> {{ this.doc_name }} </h2>
          <vue3-signature class="signature-panel" :w="signature_width" :h="signature_height" :sigOption="state.option" :disabled="state.disabled" ref="signature_ref" />
          <v-container class="text-center">
            <v-row justify="center">
              <v-col cols="12">
                <h2 class="h2-member-name"> {{ this.member_name }}</h2>
                <h2 v-if="this.member_doc.length > 1"> {{ this.member_doc }}</h2>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12">
                <v-btn v-if="show_back_button" class="sig-margin" color="white" @click="previousSignature">Voltar</v-btn>
                <v-btn class="sig-margin" color="white" @click="clear">Limpar assinatura</v-btn>
                <!-- <v-btn class="sig-margin" color="white" @click="undo">Undo</v-btn> -->
                <!-- <v-btn class="sig-margin" color="white" @click="addWaterMark">addWaterMark</v-btn> -->
                <!-- <v-btn class="sig-margin" color="white" @click="fromDataURL('https://avatars2.githubusercontent.com/u/17644818')">fromDataURL</v-btn> -->
                <v-btn class="sig-margin" color="#ff5000" @click="saveSignature('image/jpeg')">Salvar assinatura</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-dialog>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      <v-icon class="ml-1"> mdi-information-outline </v-icon> {{ snackbar_text }}
      <template v-slot:actions>
        <v-btn variant="text" @click="closeSnack"> Fechar </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { reactive, ref } from "vue";
import messages from "@/constants/messages";
import * as services from "@/services";
import Vue3Signature from "vue3-signature";

@Options({
  components: {
    Vue3Signature,
  },
})
export default class SignatureComponent extends Vue {
  public process_hash: any;
  public last_signature: any;
  public signature_process: any;
  public members: any;
  public signatures: any[] = [];
  public process_name = "";
  public doc_name = "";
  public member_name = "";
  public member_doc = "";
  public are_there_docs = false;
  public wich_signature = 0;
  public snackbar = false;
  public snackbar_text = "";
  public unsigned_docs = false;
  public title_size = window.innerWidth > 576;
  public show_signe_finish_buttons = false;
  public show_back_button = false;
  public disable_finish_button = false;
  public modal_open = false;
  public signature_ref = ref(null);
  public signature_designs: any;
  public timeout = 5000; // em milisegundos
  public signature_width = "600px";
  public signature_height = "360px";
  public download_pdf = true;
  public state = reactive({
    count: 0,
    option: {
      penColor: "rgb(114, 146, 228)",
      backgroundColor: "rgb(255,255,255)",
    },
    disabled: false,
  });

  mounted(): void {
    window.addEventListener("resize", this.handleResize);
    this.resizeSignatureSpace();
    this.process_hash = this.$route.query.process;
    this.last_signature = this.$route.query["last-signature"] == "true" ? true : false;
    this.loadPageInfo();
  }

  showSnackbar(snackbar_text_msg: string): void {
    this.snackbar_text = snackbar_text_msg;
    this.snackbar = true;
  }

  closeSnack(): void {
    this.snackbar = false;
  }

  beforeUnmount() {
    // remover o ouvinte de evento ao desmontar o componente para evitar vazamentos de memória
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    const screen_width = window.innerWidth;

    // atualize o valor da propriedade title_size quando a tela for redimensionada
    this.title_size = screen_width > 576;

    // atualize o tamanho da área de assinatura quando a tela for redimensionada, mantendo a proporção
    this.resizeSignatureSpace();
  }

  resizeSignatureSpace() {
    const screen_width = window.innerWidth;

    this.signature_width = "600px";
    this.signature_height = "360px";

    if (screen_width < 680) {
      const signature_width_size = screen_width - 80;
      const signature_height_size = (360 * signature_width_size) / 600;

      this.signature_width = signature_width_size + "px";
      this.signature_height = signature_height_size + "px";
    }
  }

  async clickable(html_id: string, is_clickable = true): Promise<any> {
    const element = document.getElementById(html_id);

    if (element) {
      if (is_clickable) {
        element.classList.remove("unclickable");
        element.classList.add("clickable");
      } else {
        element.classList.remove("clickable");
        element.classList.add("unclickable");
      }
    }
  }

  async loadPageInfo(): Promise<void> {
    const response = await this.getData(this.process_hash);
    this.process_name = "NÃO HÁ REGISTROS";

    if (Array.isArray(response?.signature_documents) && response?.signature_documents.length > 0 && response?.name) {
      const name = response?.name;
      this.process_name = `Processo de assinatura Movida - ${name}`;
      this.are_there_docs = true;
    }

    this.checkExistsUnsignedDocs();
    this.show_signe_finish_buttons = this.unsigned_docs;
    this.disable_finish_button = false; // habilita o botão "Finalizar"
  }

  async getData(process_hash: string): Promise<any> {
    try {
      const response = await services.SignatureService.getDocData(process_hash);
      this.signature_process = response?.data;
      return this.signature_process;
    } catch (e) {
      this.showSnackbar("Algo deu errado ao carregar os dados.");
      console.log("ERRO:", e);
    }
  }

  async getPdf(document_id: number, html_id: string) {
    try {
      await this.clickable(html_id, false);
      const response = await services.SignatureService.getDocPdf(this.process_hash, document_id);

      if (typeof response !== "string") {
        this.showSnackbar("Erro ao carregar PDF.");
        await this.clickable(html_id, true);
        return;
      }

      const pdf_decoded = atob(response);
      const blob = new Blob([new Uint8Array(pdf_decoded.split("").map((char) => char.charCodeAt(0)))], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);

      if (this.download_pdf) {
        // ao invés de abrir o pdf numa nova aba, baixa o arquivo diretamente
        const docUrl = document.createElement("a");
        docUrl.href = pdfUrl;
        const pdf_file_name = this.process_name + "_" + document_id + ".pdf";
        docUrl.setAttribute("download", pdf_file_name);
        document.body.appendChild(docUrl);
        docUrl.click();
      } else {
        // abre o pdf numa nova aba (é o padrão)
        window.open(pdfUrl, "_blank");
      }

      await this.clickable(html_id, true);
    } catch (error) {
      console.error("Erro ao carregar PDF", error);
      this.showSnackbar("Erro ao carregar PDF.");
    } finally {
      await this.clickable(html_id, true);
    }
  }

  // Envia as assinaturas para o ms para que sejam salvas
  async finishSignatureProcess(): Promise<any> {
    let unsuccessful_response = false;
    this.disable_finish_button = true; // evita que o botão "Finalizar" seja clicado mais de uma vez
    try {
      this.showSnackbar("Aguarde que estamos salvando as assinaturas.");
      for (const signature of this.signatures) {
        const response = await services.SignatureService.storeDocSignature(signature.hash, signature.member_id, signature.image);
        unsuccessful_response = response?.success ? false : true;
      }

      if (unsuccessful_response) {
        const time = this.timeout;
        this.showSnackbar("Alguma assinatura falhou, a página será atualizada em " + time / 1000 + " segundos para que você possa tentar novamente.");
        await this.delay(time);
      } else {
        // adiciona o parâmetro success=true na url apenas para o app android entender que o processo foi concluído
        const current_url = window.location.href;
        const params = new URLSearchParams(current_url.split("?")[1] || "");
        params.append("success", "true");
        const updated_url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
        window.history.pushState({ path: updated_url }, "", updated_url);
      }

      this.loadPageInfo();
    } catch (e) {
      this.showSnackbar("Algo deu errado ao tentar salvar as assinaturas.");
      console.log("ERRO", e);
    }
  }

  async delay(ms: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  // Verifica se existe algum documento que ainda não foi assinado
  checkExistsUnsignedDocs(): void {
    this.members = [];
    if (this.signature_process && this.signature_process.signature_documents) {
      for (let document_index = 0; document_index < this.signature_process.signature_documents.length; document_index++) {
        const document = this.signature_process.signature_documents[document_index];
        if (document.members) {
          for (let member_index = 0; member_index < document.members.length; member_index++) {
            const member = document.members[member_index];
            const new_member = { ...member, document_name: document.name };
            if (!member.signature_file) {
              this.members.push(new_member);
              this.unsigned_docs = true;
            }
          }
        }
      }
    }
  }

  signaturePositionControl(): void {
    const last_position = this.members.length - 1;

    if (this.wich_signature < 0) {
      this.wich_signature = 0;
    } else if (this.wich_signature > last_position) {
      this.wich_signature = last_position;
    }

    // gerencia se vai exibir o botão voltar ou não na parte das assinaturas
    this.show_back_button = false;
    if (this.wich_signature > 0) {
      this.show_back_button = true;
    }
  }

  previousSignature(): void {
    this.wich_signature -= 1;
    this.signaturePositionControl();
    this.signeIt();
  }

  nextSignature(): void {
    this.wich_signature += 1;
    const signature_position = this.wich_signature;
    this.signaturePositionControl();

    const last_position = this.members.length - 1;
    if (signature_position > last_position) {
      this.modal_open = false;
      this.unsigned_docs = false;
      return;
    }
    this.signeIt();
  }

  async signeIt(): Promise<void> {
    this.signaturePositionControl();

    const member_data = this.members[this.wich_signature];

    const savedSignature = this.signatures.find((item) => {
      return item.document == member_data.document;
    });

    if (savedSignature) {
      this.saveSignature("image/jpeg", savedSignature.image);

      return;
    }
    const url = member_data.signature_file_url ?? "";

    await this.getLastSignature(member_data.document);

    this.modal_open = true;
    this.doc_name = "Assinatura documento " + member_data.document_name;
    this.member_name = member_data.name;
    this.member_doc = this.maskCpfCnpj(member_data.document);

    if (this.signatures && this.signatures[this.wich_signature]?.image) {
      const image = this.signatures[this.wich_signature].image;

      this.$nextTick(() => {
        this.fromDataURL(image);
      });
    } else if (url !== "" && this.isString(url)) {
      this.imageUrlToBase64(url)
        .then((base64_image) => {
          this.$nextTick(() => {
            this.fromDataURL(base64_image);
          });
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  }

  imageUrlToBase64(imageUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", imageUrl, true);
      xhr.responseType = "blob";

      xhr.onload = () => {
        if (xhr.status === 200) {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (typeof reader.result === "string") {
              resolve(reader.result);
            } else {
              reject(new Error("Failed to convert image to base64."));
            }
          };
          reader.readAsDataURL(xhr.response);
        } else {
          reject(new Error("Failed to fetch image."));
        }
      };

      xhr.onerror = () => {
        reject(new Error("Network error occurred."));
      };

      xhr.send();
    });
  }

  maskCpfCnpj(value: number | string): string {
    let formated = String(value);
    const string_value = formated.replace(/\D/g, ""); // Remove caracteres não numéricos

    if (string_value.length === 11) {
      // Verifica se é CPF e coloca a máscara
      formated = string_value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (string_value.length === 14) {
      // Verifica se é CNPJ e coloca a máscara
      formated = string_value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }

    // Se não for CPF nem CNPJ, retorna o valor no formato em que veio
    return formated;
  }

  isString(value: any): value is string {
    return typeof value === "string";
  }

  async getLastSignature(document: string): Promise<void> {
    if (!this.last_signature || typeof this.signatures[this.wich_signature]?.image !== "undefined") {
      return;
    }

    const member_last_signature = await services.SignatureService.getSignatureByDocument(document);
    const base64Signature = member_last_signature?.data?.file_base64;

    if (typeof base64Signature !== "undefined") {
      this.signatures[this.wich_signature] = {
        hash: this.process_hash,
        member_id: this.members[this.wich_signature].id,
        image: "data:image/jpeg;base64," + member_last_signature?.data?.file_base64,
      };
    }
  }

  /************* Os métodos abaixo controlam o componente Vue3Signature *************/

  // habilita ou desabilita o desenho/assinatura
  handleDisabled(): void {
    this.state.disabled = !this.state.disabled;
  }

  // limpa o desenho/assinatura
  clear(): void {
    const signature_ref = this.$refs.signature_ref as any;
    signature_ref?.clear();
  }

  // verifica se existe algum desenho/assinatura
  isEmpty(): boolean {
    const signature_ref = this.$refs.signature_ref as any;
    return signature_ref.isEmpty();
  }

  // desfaz o último desenho/assinatura
  undo(): void {
    const signature_ref = this.$refs.signature_ref as any;
    signature_ref.undo();
  }

  // adiciona uma marca d'água no desenho/assinatura
  addWaterMark(): void {
    const signature_ref = this.$refs.signature_ref as any;
    signature_ref.addWaterMark({
      text: "Marca d'água", // watermark text, > default ''
      font: "20px Arial", // mark font, > default '20px sans-serif'
      style: "fill", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
      fillStyle: "red", // fillcolor, > default '#333'
      strokeStyle: "blue", // strokecolor, > default '#333'
      x: 100, // fill positionX, > default 20
      y: 200, // fill positionY, > default 20
      sx: 100, // stroke positionX, > default 40
      sy: 200, // stroke positionY, > default 40
    });
  }

  // exibe um desenho/assinatura já existente
  /*
      Obs.: para que não haja problema na hora de salvar esse desenho/assinatura
    é necessário que ele seja convertido para base64 antes, se utilizar direto a
    URL do desenho/assinatura, irá dar erro ao gravar.
      O método que converte para base64 é `imageUrlToBase64()`.
  */
  fromDataURL(url: string): void {
    const signature_ref = this.$refs.signature_ref as any;
    signature_ref.fromDataURL(url);
  }

  // pega o desenho/assinatura feito e grava numa variável, além de preparar para enviar para o MS
  saveSignature(image_type = "image/jpeg", previousImage = null): void {
    const member = this.members[this.wich_signature];

    if (previousImage) {
      this.signatures[this.wich_signature] = {
        hash: this.process_hash,
        member_id: member.id,
        image: previousImage,
        document: member.document,
      };

      this.clear();
      this.nextSignature();
      return;
    }

    if (this.isEmpty()) {
      this.showSnackbar("É necessário assinar para prosseguir.");
      return;
    }

    const signature_ref = this.$refs.signature_ref as any;
    const save = signature_ref.save(image_type);

    this.signatures[this.wich_signature] = {
      hash: this.process_hash,
      member_id: member.id,
      image: save,
      document: member.document,
    };

    this.clear();
    this.nextSignature(); // depois de gravar a assinatura, vai para a próxima assinatura
  }
}
</script>

<style lang="css">
.signature-panel {
  margin: 0 auto;
  border: 1px solid black;
}

.orange {
  background-color: #ff5000;
}

.maxsize {
  margin-left: 30px;
}

.signed-background-color {
  background-color: #dff0d8;
}

.unsigned-background-color {
  background-color: #f8d7da;
}

.text-font {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.clickable {
  cursor: pointer;
  text-decoration: underline;
}

.unclickable {
  pointer-events: none;
}

.actionBtn,
.actionBtn:hover {
  background-color: #ff5000;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  color: white;
  text-decoration: none;
  margin-top: 20px;
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

#members-list {
  margin: 0px;
}

.sig-margin {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.h2-doc-name {
  font-weight: normal;
}

.h2-member-name {
  margin-bottom: 3px;
}

.modal-background-color {
  background-color: #f0f0f0;
}

.disabled-btn {
  pointer-events: none;
  opacity: 0.5;
}

.width-100 {
  width: 100%;
}

.content-padding {
  padding-bottom: 50px;
}

.titles-1 {
  font-size: calc(1.7em + 0.5vw);
  word-wrap: break-word;
}

.titles-2 {
  font-size: calc(1.2em + 0.5vw);
  word-wrap: break-word;
}

.hide-overflow {
  overflow: hidden;
}
</style>
